import initialState from '../constants/initialState';
import * as types from '../constants/types';

export default (state = initialState.articles, action) => {
	switch (action.type) {
		case types.articles.FETCH_ARTICLES:
			return {
				...state,
				all: [...state.all, ...action.payload.articles],
			};
		case types.articles.END_ARTICLES:
			return {
				...state,
				all: [...state.all, ...action.payload.articles],
				end: true,
			};
		case types.articles.GET_ARTICLES:
			return {
				...state,
				all: action.payload.articles,
			};
		case types.articles.ADD_ARTICLE:
			return {
				...state,
				all: [action.payload.article, ...state.all],
			};
		case types.articles.EDIT_ARTICLE:
			return {
				...state,
				all: state.all.map(article => {
					if (article._id === action.payload.article._id) {
						return action.payload.article;
					}

					return article;
				}),
			};
		case types.articles.ADD_VIEWS:
			return {
				...state,
				all: state.all.map(article => {
					if (article.slug === action.payload.slug) {
						return {...article, views: article.views + 1};
					}

					return article;
				}),
			};
		case types.articles.REMOVE_ARTICLE:
			return {
				...state,
				all: state.all.filter(article => article._id !== action.payload.articleId),
			};
		case types.articles.ADD_COMMENT:
			return {
				...state,
				all: state.all.map(article => {
					if (article._id === action.payload.comment.articleId) {
						return {
							...article,
							comments: [action.payload.comment, ...article.comments],
						};
					}

					return article;
				}),
			};
		case types.articles.REMOVE_COMMENT:
			return {
				...state,
				all: state.all.map(article => {
					if (article._id === action.payload.comment.articleId) {
						return {
							...article,
							comments: article.comments.filter(
								comment => comment._id !== action.payload.comment._id,
							),
						};
					}

					return article;
				}),
			};
		default:
			return state;
	}
};
